import * as XLSX from "xlsx";
import { API } from "../constant/api";

export function convertDate(inputFormat) {
  function pad(s) {
    return s < 10 ? "0" + s : s;
  }
  let d = new Date(inputFormat);
  return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join("/");
}

export const addOneToDate = (currDate) => {
  currDate.setDate(currDate.getDate() + 1);
  return (currDate = currDate.toISOString().split("T")[0]);
};

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function debounce(fn, delay = 250) {
  let timeout;

  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}

//credit - gourav
export const urlToObject = async (fileUrl) => {
  const response = await fetch(fileUrl);
  return await response.blob();
  // const blob = await response.blob();
  // const file = new File([blob], "image.jpg", { type: blob.type });
  // return file;
};

export const isValidUrl = (urlString) => {
  var urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};

export const capitalizeWord = (string) => {
  const newString = string
    .split("_")
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(" ");
  return newString;
};

export const downloadExcel = (data, name) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
  //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
  XLSX.writeFile(workbook, `${name}.xlsx`);
};

export function arrayMoveMutable(array, fromIndex, toIndex) {
  const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;

  if (startIndex >= 0 && startIndex < array.length) {
    const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;

    const [item] = array.splice(fromIndex, 1);
    array.splice(endIndex, 0, item);
  }
}

export const fetchImageSize = async (imageUrl) => {
  try {
    // Load the image
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    // Calculate the size in MB
    const sizeInMB = blob.size / (1024 * 1024); // Bytes to MB

    // Update the state with the size
    return sizeInMB.toFixed(2); // Limit to 2 decimal places
  } catch (error) {
    console.error("Error fetching image:", error);
  }
};

//TODO: UPDATE THESE FUNCTIONS --- START.
export function getentityTypeKey(entityType) {
  return entityType === "vendor"
    ? "vendor"
    : entityType === "customer"
    ? "customers"
    : entityType === "country"
    ? "countries"
    : entityType === "product"
    ? "products"
    : "manufactures";
}

export function getEntity(entityType) {
  return entityType === "vendors"
    ? "vendor"
    : entityType === "customers"
    ? "customer"
    : entityType === "countries"
    ? "country"
    : entityType === "products"
    ? "product"
    : "supplier";
}

export function getEntityTitle(entityType) {
  return entityType === "vendors"
    ? "Vendor"
    : entityType === "customers"
    ? "Customer"
    : entityType === "countries"
    ? "Country"
    : entityType === "products"
    ? "Product"
    : "Supplier";
}

export function getEntityTextONE(entityType) {
  return entityType === "vendor"
    ? "vendors"
    : entityType === "customer"
    ? "customers"
    : entityType === "country"
    ? "countries"
    : entityType === "product"
    ? "products"
    : "suppliers";
}

export function getEntityTextTWO(entityType) {
  return entityType === "vendor"
    ? "Vendor"
    : entityType === "customer"
    ? "Customer"
    : entityType === "country"
    ? "Country"
    : entityType === "product"
    ? "Product"
    : "Supplier";
}

//TODO: UPDATE THESE FUNCTIONS --- END.

export const createSlug = (value) => value.toLowerCase().split(" ").join("-");

const keyObj = {
  product: "NMP",
  productVariant: "NMPV",
};

export const createCustomId = (table, value, increment) => {
  let num = value + increment;
  let len = num.toString().length;
  let str = "";
  for (let i = 1; i <= 8 - len; i++) {
    str += "0";
  }
  str += num;
  return `${keyObj[table]}${str}`;
};

export const renderMultipleImagePreviews = (
  selectedFiles,
  id,
  handleRemoveImage
) => {
  if (selectedFiles[id]?.length < 1) return null;

  return (
    <div>
      <div className="offerImageCard">
        {selectedFiles[id]?.map((file, index) => (
          <div className="offerCardImg" key={`file.name.${index}`}>
            <img
              src={
                typeof file == "string" && file.startsWith("uploads")
                  ? `${API.PORT}/${file}`
                  : URL.createObjectURL(file)
              }
              alt={file.name}
              style={{
                width: "120px",
                height: "90px",
                cursor: "pointer",
              }}
            />
            {/* {file.name} ({file.size} bytes) */}
            <button
              className="uploadDeleteBtn"
              type="button"
              onClick={() => handleRemoveImage(index, id, file)}
            >
              <span className="svg-icon svg-icon-md svg-icon-danger">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M6,8 L6,20.5 C6,21.3284271 6.67157288,22 7.5,22 L16.5,22 C17.3284271,22 18,21.3284271 18,20.5 L18,8 L6,8 Z"
                      fill="#000000"
                      fillRule="nonzero"
                    ></path>
                    <path
                      d="M14,4.5 L14,4 C14,3.44771525 13.5522847,3 13,3 L11,3 C10.4477153,3 10,3.44771525 10,4 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                  </g>
                </svg>
              </span>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export const combineImage = (image) => {
  let combinedArray = [];
  let indices = {};

  let startIndex = 0;

  for (const key in image) {
    if (image.hasOwnProperty(key)) {
      let arr = image[key];

      arr = arr?.filter((item) => !item.toString().startsWith("uploads"));
      // if (arr?.some((file) => file?.startsWith("uploads"))) {
      //   continue;
      // }
      indices[key] = {
        start_index: startIndex,
        end_index: startIndex + arr?.length > 0 ? arr?.length - 1 : 0,
      };
      combinedArray = combinedArray.concat(arr);
      startIndex += arr?.length;
    }
  }
  return [combinedArray, indices];
  // console.log("Combined Array:", combinedArray);
  // console.log("Indices:", indices);
};

export const itterateArray = (arr) => {
  console.log("Array:", arr);
  if (!arr || arr?.length < 1) return [];
  if (arr.length == 1) return arr;
  const desiredArray = [...Array(Math.ceil(arr[1] - arr[0] + 1))].map(
    (_, i) => arr[0] + i
  );
  return desiredArray;
};

export const roundNumber = (num) => {
  if (!num || isNaN(num)) {
    return 0;
  }
  return Math.round(num * 10) / 10;
};
